import { render, staticRenderFns } from "./editFaq.vue?vue&type=template&id=d00cd50c&"
import script from "./editFaq.vue?vue&type=script&lang=js&"
export * from "./editFaq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports